// extracted by mini-css-extract-plugin
export default {"base":"vp_txl7Q","loader":"vp_GIZXj","item":"vp_W0dON"};